import { PaymentType, HaulerStatusEnum, HaulerType, InfoStatusEnum } from './enums'
import { DriveLicenseInformation } from './DriveLicenseInformation'
import { VehicleInformation } from './VehicleInformation'

export class HaulerInfo {
    username: string
    deviceName: string
    deviceId: string
    firstName: string
    lastName: string
    birthday: number
    avatar: string
    companyId: string
    mailingAddress: string
    address: any
    city: string
    state: string
    zip: string
    primaryPhone: string
    paymentType: PaymentType
    starRating: number
    numberRating: number
    awsStripeAccount: string
    msaId: string
    type: HaulerType
    certificationLevel: string
    driveLicenseInformation: DriveLicenseInformation
    vehicleInformation: VehicleInformation
    status: HaulerStatusEnum
    infoStatus: InfoStatusEnum
    modifyDate: number
    active: HaulerStatusEnum
    notes: string
    lastSeen: number
    createDate: number
    providerId: string
    providerName: string
    cognitoId: string
    msaIds: Array<string>
}



// WEBPACK FOOTER //
// ./src/types/HaulerInfo.ts